export type StarlingRoute = "index";

export const STARLING_COMMON_CONFIG = {
  api_key: "00724780f4b811e9b3c47f9631f4d4f2",
  // eslint-disable-next-line no-undef
  zoneHost: STARLING_DOMAIN,
  test: false,
  fallbackLang: ['en'],
  // eslint-disable-next-line no-undef
  TEAChannelDomain: TEA_DOMAIN
};

export const STARLING_BASIC_ROUTE = "index";

export const DEFAULT_LANG = "en";

export type StarlingNamespaceOption = Record<string, string[]>;

export const EXTENDS_STARLING_KEY_MAP: Record<string, string> = {
  region: "2c4cfab0514011e9ba3ec93d24ca2925"
};

// 路由和对应的空间配置，会在这些key 的value上追加 common 空间（包含表单，header，footer等文案的共用空间），
// 若是没有文案的页面，不用加在列表中（才不会追加 common 空间）
export const STARLING_NAMESPACES: StarlingNamespaceOption = {
  "success-register": [],
  "success-register-home": [],
  "success-leave-info": [],
  index: [],
  slug: ["lp_smb_hub"],
  lp1: ["tt4b"],
  lp2: ["tt4b"],
  lp3: ["tt4b"],
  "registration-form": [],
  tt4b: ["tt4b"],
  "tt4b-new": ["tt4b", "b2bcredit"],
  "tt4bnew-new": ["tt4b", "b2bcredit"],
  tt4bnew: ["tt4b"],
  b2bcredit: ["b2bcredit"],
  "b2bcredit-new": ["b2bcredit"],
  "b2bcredit-lead": ["b2bcredit"],
  "lead-form": [],
  "b2bcredit-caseslatetell": ["b2bcredit"],
  "b2bcredit-casestudy": ["b2bcredit"],
  b2bs: ["b2bcredit"],
  "ttba-casestudy": ["b2bcredit"],
  "b2bcredit-ecommerce": ["b2bcredit"],
  "ttba-ecommerce": ["b2bcredit"],
  caseslatetell: ["b2bcredit"],
  princesspolly: ["b2bcredit"],
  casestudy: ["b2bcredit"],
  ecommerce: ["b2bcredit"],
  holidayb: ["b2bcredit"],
  holidayr: ["b2bcredit"],
  holiday: ["b2bcredit"],
  savannah: ["b2bcredit"],
  bestpractice: [],
  home: [],
  "payment-result": [],
  "payment-result-iframe": [],
  "JP-lp1": ["tt4b"],
  "JP-lp2": ["tt4b"],
  "JP-lp3": ["tt4b"],
  "unsubscription-lead": ["unsubscription"],
  supportblackbusinesses: [],
  "holiday-2020": ["b2bcredit"],
  "ecommerce-new": ["b2bcredit"],
  tt4bv2: ["b2bcredit"],
  "dont-make-ads-make-tiktoks-smb": ["lp_smb_hub"]
};

export const EXTENDS_NAMESPACES: StarlingNamespaceOption = {
  "success-register": [],
  "success-register-home": [],
  "success-leave-info": [],
  index: [],
  slug: ["region"],
  lp1: ["region"],
  lp2: ["region"],
  lp3: ["region"],
  "registration-form": ["region"],
  tt4b: ["region"],
  "tt4b-new": ["region"],
  "tt4bnew-new": ["region"],
  tt4bnew: ["region"],
  b2bcredit: ["region"],
  "b2bcredit-new": ["region"],
  "b2bcredit-lead": ["region"],
  "lead-form": ["region"],
  "b2bcredit-caseslatetell": ["region"],
  "b2bcredit-casestudy": ["region"],
  b2bs: ["region"],
  "ttba-casestudy": ["region"],
  "b2bcredit-ecommerce": ["region"],
  "ttba-ecommerce": ["region"],
  caseslatetell: ["region"],
  princesspolly: ["region"],
  casestudy: ["region"],
  ecommerce: ["region"],
  holidayb: ["region"],
  holidayr: ["region"],
  holiday: ["region"],
  savannah: ["region"],
  bestpractice: [],
  home: ["region"],
  "payment-result": [],
  "payment-result-iframe": [],
  "JP-lp1": ["region"],
  "JP-lp2": ["region"],
  "JP-lp3": ["region"],
  "unsubscription-lead": [],
  supportblackbusinesses: [],
  "holiday-2020": ["region"],
  "ecommerce-new": ["region"],
  tt4bv2: ["region"],
  "dont-make-ads-make-tiktoks-smb": ["region"],
};
